import { ProjectWizardContext } from 'context/Context';
import { Form as FormFormik, Formik } from 'formik';
import { useContext, useEffect } from 'react';
import { Col, Form, Row } from 'react-bootstrap';

const getInitialExtras = (extras, values) => {
  const initialExtras = {};

  extras.forEach(category => {
    if (!initialExtras[category.key]) initialExtras[category.key] = {};
    category.extras.forEach(extra => {
      if (!values[category.key]) {
        initialExtras[category.key][extra.key] = false;
      } else {
        initialExtras[category.key][extra.key] =
          values[category.key][extra.key] || false;
      }
    });
  });

  return initialExtras;
};

const form = {
  extras: [
    {
      title: 'Servicios esenciales',
      key: 'serviciosEsenciales',
      extras: [
        {
          title: 'ABL',
          key: 'abl'
        },
        {
          title: 'AYSA',
          key: 'aysa'
        },
        {
          title: 'Gas natural',
          key: 'gas'
        },
        {
          title: 'Electricidad',
          key: 'electricidad'
        },
        {
          title: 'Internet/Wifi',
          key: 'internet_wifi'
        },
        {
          title: 'TV/Cable',
          key: 'tv_cable'
        },
        {
          title: 'Línea telefónica',
          key: 'telefono'
        }
      ]
    },
    {
      title: 'Vista',
      key: 'vista',
      extras: [
        {
          title: 'A la calle',
          key: 'calle'
        },
        {
          title: 'A pulmón de manzana',
          key: 'pulmonManzana'
        },
        {
          title: 'A jardín',
          key: 'jardin'
        },
        {
          title: 'A plaza',
          key: 'plaza'
        },
        {
          title: 'Abierta',
          key: 'abierta'
        }
      ]
    },
    {
      title: 'Seguridad',
      key: 'seguridad',
      extras: [
        {
          title: 'Alarma en la propiedad',
          key: 'alarma'
        },
        {
          title: 'Puerta blindada',
          key: 'puertaBlindada'
        },
        {
          title: 'Grupo electrógeno',
          key: 'grupoElectrogeno'
        }
      ]
    },
    {
      title: 'Calefacción',
      key: 'calefaccion',
      extras: [
        {
          title: 'Ventilador de techo',
          key: 'ventilador'
        },
        {
          title: 'Aire acondicionado',
          key: 'aireAcondicionado'
        },
        {
          title: 'Split frío/calor',
          key: 'split'
        },
        {
          title: 'Caldera (central)',
          key: 'caldera_central'
        },
        {
          title: 'Caldera (individual)',
          key: 'caldera_individual'
        },
        {
          title: 'Calefacción (central)',
          key: 'calefaccion_central'
        },
        {
          title: 'Calefacción (estufa a gas)',
          key: 'calefaccion_estufa_gas'
        },
        {
          title: 'Calefacción (losa central)',
          key: 'calefaccion_losa_central'
        },
        {
          title: 'Calefacción (losa individual)',
          key: 'calefaccion_losa_individual'
        },
        {
          title: 'Calefacción (radiadores central)',
          key: 'calefaccion_radiadores_central'
        },
        {
          title: 'Calefacción (radiadores individuales)',
          key: 'calefaccion_radiadores_individual'
        },
        {
          title: 'Calefacción (placas bajo consumo)',
          key: 'calefaccion_placas_bajo_consumo'
        },
        {
          title: 'Termotanque/Calefón',
          key: 'termotanque_calefon'
        },
        {
          title: 'Chimenea',
          key: 'chimenea'
        }
      ]
    },
    {
      title: 'Vigilancia',
      key: 'vigilancia',
      extras: [
        {
          title: 'Encargado',
          key: 'encargado'
        },
        {
          title: 'Encargado (virtual/pantalla)',
          key: 'encargado_virtual'
        },
        {
          title: 'Portero eléctrico',
          key: 'portero_electrico'
        },
        {
          title: 'Cámaras de seguridad',
          key: 'camaras'
        },
        {
          title: 'Vigilancia (24hs)',
          key: 'vigilancia_24hs'
        },
        {
          title: 'Vigilancia (diurna)',
          key: 'vigilancia_diurna'
        },
        {
          title: 'Vigilancia (nocturna)',
          key: 'vigilancia_nocturna'
        },
        {
          title: 'Vigilancia (fin de semana)',
          key: 'vigilancia_fin_de_semana'
        }
      ]
    },
    {
      title: 'Adicionales',
      key: 'adicionales',
      extras: [
        {
          title: 'Termotanque (eléctrico)',
          key: 'termotanque_electrico'
        },
        {
          title: 'Termotanque (gas)',
          key: 'termotanque_gas'
        },
        {
          title: 'Cocina (eléctrica)',
          key: 'cocina_electrica'
        },
        {
          title: 'Cocina (gas)',
          key: 'cocina_gas'
        },
        {
          title: 'Amoblado',
          key: 'amoblado'
        },
        {
          title: 'Placards',
          key: 'placards'
        },
        {
          title: 'Cancha de paddle',
          key: 'cancha_paddle'
        },
        {
          title: 'Cancha de tenis',
          key: 'cancha_tenis'
        },
        {
          title: 'Gimnasio',
          key: 'gimnasio'
        },
        {
          title: 'Hidromasaje',
          key: 'hidromasaje'
        },
        {
          title: 'Laundry',
          key: 'laundry'
        },
        {
          title: 'Microcine',
          key: 'microcine'
        },
        {
          title: 'Parrilla',
          key: 'parrilla'
        },
        {
          title: 'Piscina',
          key: 'piscina'
        },
        {
          title: 'Sala de juegos',
          key: 'sala_de_juegos'
        },
        {
          title: 'Sauna',
          key: 'sauna'
        },
        {
          title: 'Solarium',
          key: 'solarium'
        },
        {
          title: 'Spa',
          key: 'spa'
        },
        {
          title: 'SUM',
          key: 'sum'
        },
        {
          title: 'Centros comerciales cercanos',
          key: 'centros_comerciales_cercanos'
        },
        {
          title: 'Escuelas cercanas',
          key: 'escuelas_cercanas'
        },
        {
          title: 'Parques cercanos',
          key: 'parques_cercanos'
        },
        {
          title: 'Estacionamiento de visitas',
          key: 'estacionamiento_visitas'
        }
      ]
    }
  ]
};

const Extras = () => {
  const { data, handleSubmit, setStepStatus, yupSubmitRef /* , form */ } =
    useContext(ProjectWizardContext);

  const extras = form.extras;

  return (
    <div>
      <Formik
        initialValues={
          extras
            ? {
                ...data,
                extras: getInitialExtras(extras, data.extras || {})
              }
            : {
                ...data
              }
        }
        onSubmit={values => handleSubmit(values)}
      >
        {({ values, setValues }) => {
          //hanlders
          useEffect(() => {
            setStepStatus(prev => ({
              ...prev,
              ...values
            }));
          }, [values]);
          return (
            <FormFormik>
              {extras ? (
                <Row className="g-3">
                  {extras
                    .slice()
                    .sort((a, b) => b.extras.length - a.extras.length)
                    .map(category => (
                      <Col xs={12} md={6} lg={4} key={category.key}>
                        <h5>{category.title}</h5>

                        {category.extras
                          .slice()
                          .sort((a, b) => a.title.localeCompare(b.title))
                          .map(extra => (
                            <Form.Group
                              className="d-flex gap-2 align-items-center"
                              key={extra.key}
                            >
                              <Form.Check
                                type="checkbox"
                                name={extra.key}
                                onChange={e =>
                                  setValues(prev => ({
                                    ...prev,
                                    extras: {
                                      ...prev.extras,
                                      [category.key]: {
                                        ...prev.extras[category.key],
                                        [extra.key]: e.target.checked
                                      }
                                    }
                                  }))
                                }
                                checked={values.extras[category.key][extra.key]}
                              />

                              <Form.Label className="m-0">
                                {extra.title}
                              </Form.Label>
                            </Form.Group>
                          ))}
                      </Col>
                    ))}
                </Row>
              ) : (
                <div className="text-center">
                  <h4>Esta propiedad no tiene extras</h4>
                </div>
              )}
              <button hidden ref={yupSubmitRef}></button>
            </FormFormik>
          );
        }}
      </Formik>
    </div>
  );
};

export default Extras;
